/** Форматирование для экранов загрузки РД: склонение по числу и размеры файлов. */

/** «1 файл», «2 файла», «5 файлов». */
export function plural(n: number, [one, few, many]: [string, string, string]): string {
  const m10 = n % 10;
  const m100 = n % 100;
  if (m10 === 1 && m100 !== 11) return one;
  if (m10 >= 2 && m10 <= 4 && (m100 < 12 || m100 > 14)) return few;
  return many;
}

export function formatMb(bytes: number): string {
  return `${(bytes / 1024 / 1024).toLocaleString('ru-RU', { maximumFractionDigits: 1 })} МБ`;
}

/** Размер файла: КБ, МБ или ГБ. */
export function formatSize(bytes: number): string {
  if (bytes < 1024 * 1024) {
    return `${Math.max(1, Math.round(bytes / 1024)).toLocaleString('ru-RU')} КБ`;
  }
  if (bytes < 1024 * 1024 * 1024) return formatMb(bytes);
  return `${(bytes / 1024 ** 3).toLocaleString('ru-RU', { maximumFractionDigits: 2 })} ГБ`;
}
